export default __webpack_public_path__ + "static/media/Bone-picker's Belt.04e465d0.jpg";